import Table from 'common/table/table';
import { ThemeHeader } from 'common/table/table-helper';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Div } from 'ui';


const Wrapper = styled(Div)`
  box-shadow: rgba(0, 0, 0, 0.27) 0px;  
  border-radius: 4px;
  background-color: #fff;
  margin-bottom: 20px;
`;

const MeasuringPoints = ({
  measuringPoints = [],
  intl,
  form,
  pageSize = 10,
}) => {
  const points = measuringPoints;

  const { getFieldDecorator } = form;

  getFieldDecorator('measuringPoints', {
    initialValue: points,
  });

  const columns = [
    {
      id: 'type',
      displayName: intl.formatMessage({ id: 'equipment.measuringPoints.TYPE' }),
      fieldName: 'type',
    },
    {
      id: 'value',
      displayName: intl.formatMessage({ id: 'equipment.measuringPoints.MEASURING_POINT' }),
      fieldName: 'value',
      renderFn: value => <><FormattedNumber value={value?.value} /> {value?.unit}</>,
    },
    {
      id: 'createdOn',
      displayName: intl.formatMessage({ id: 'equipment.measuringPoints.DATE' }),
      fieldName: 'createdOn',
      renderFn: value => <FormattedDate value={value?.createdOn} />,
    },
    {
      id: 'createdBy',
      displayName: intl.formatMessage({ id: 'equipment.measuringPoints.OWNER' }),
      fieldName: 'createdBy',
      tooltip: row => row.createdBy,
    },
  ];

  const renderHeader = () => <>
    <ThemeHeader inlineTable={true}>
      <FormattedMessage id='equipment.measuringPoints.MEASURING_POINTS' />
      {' '}({points?.length || 0})
    </ThemeHeader>
  </>;


  return (
    <Wrapper marginBottom={20} data-test-id='measuring-points'>
      <Table
        renderCustomHeader={renderHeader}
        hasCustomHeader={true}
        columns={columns}
        data={points?.slice(0, pageSize) || []}
        fullWidth={true}
        lightHeader={true}
      />
    </Wrapper>
  );
};

MeasuringPoints.propTypes = {
  measuringPoints: PropTypes.array,
  intl: PropTypes.object.isRequired,
  form: PropTypes.object,
  pageSize: PropTypes.number,
};

export default injectIntl(MeasuringPoints);
